import * as React from 'react';
import { encodeText } from '../../ta-services/ta-utils';
import { TaAnswerData } from '../../ta-shared';
import { TaResultSummaryBar } from './ta-result-summary-bar/comp';

type TaResultSummaryProps = {
	userAnswerssData: TaAnswerData[];
	fullName: string;
	company: string;
	email: string;
};

export const TaResultSummary = ({
	userAnswerssData,
	fullName,
	company,
	email
}: TaResultSummaryProps) => {
	const totalScore = userAnswerssData.reduce(
		(acc: number, value: any) => acc + value.score,
		0
	);
	const subjectScore = (data: TaAnswerData[], filter: string): number => {
		const res = data
			.filter((answer: any) => answer.subject.toUpperCase() === filter)
			.reduce((acc: number, value: any) => acc + value.score, 0);
		return res;
	};

	const renderDetailsScoreTitle = (score: number) => {
		if (score > 85) {
			return 'your support tech stack is onwards and upwards from here!';
		} else if (score > 60) {
			return 'your support tech stack is okay.';
		} else {
			return 'it’s time to make some much-needed improvements.';
		}
	};

	const renderDetailsScoreSubtitle = (score: number) => {
		if (score > 85) {
			return 'Now, let\'s take it to greater heights! Here are some tips and resources to help maximize your stack:';
		} else if (score > 60) {
			return 'Now, let\'s see how we can bump up that score with practical tips and resources to help enhance and maximize your stack:';
		} else {
			return 'We\'ve set the foundation with practical tips and resources that\'ll go a long way toward helping you enhance your stack:';
		}
	};

	const renderSummaryScoreTitle = (score: number) => {
		if (score >= 60) {
			return 'Ready to take your tech stack to the next level?';
		} else {
			return 'Tap into the real value of your customer support.';
		}
	};

	const renderSummaryScoreText = (score: number) => {
		if (score >= 60) {
			return 'See how easy it is to manage and optimize your support operation with all essentials in one place.';
		} else {
			return 'See how easy it is to manage and optimize your support operation, connect better with customers, boost agent productivty, and much more.';
		}
	};

	return (
		<div className='ta-result-summary-container'>
			<div className='ta-result-summary'>
				<div className='ta-result-summary-logo'>
					<img
						src='https://static.wixstatic.com/media/dba05e_b1eb7b6bff2d4b328c35d484a47a7dd0~mv2.png'
						alt='logo'
					/>
				</div>
				<div className='ta-result-summary-grade'>
					<div
						className='ta-donut-base-circle'
						style={{background: `conic-gradient(#7493CE ${totalScore}%, #1A3777 0%)`}}
					>
						<div className='ta-donut-inner-circle' />
					</div>
					<div className='ta-result-summary-grade-score'>{totalScore}</div>
				</div>
				<div className='ta-result-summary-company'>{company}</div>
				<div className='ta-result-summary-header'>
					<div className='ta-result-summary-header_title'>
						{fullName || 'Hey'},{' '}
						{renderDetailsScoreTitle(totalScore)}
					</div>
					<div className='ta-result-summary-header_subtitle'>
						{renderDetailsScoreSubtitle(totalScore)}
					</div>
				</div>
				<TaResultSummaryBar
					currentValue={subjectScore(userAnswerssData, 'TECH STACK')}
					maxValue={25}
					barColor='#40c6bb'
					subject={'Tech stack'}
				/>
				<TaResultSummaryBar
					currentValue={subjectScore(userAnswerssData, 'PRODUCTIVITY')}
					maxValue={25}
					barColor='#db3838'
					subject={'Productivity'}
				/>
				<TaResultSummaryBar
					currentValue={subjectScore(userAnswerssData, 'SCALABILITY')}
					maxValue={25}
					barColor='#40c6bb'
					subject={'Scalability'}
				/>
				<TaResultSummaryBar
					currentValue={subjectScore(userAnswerssData, 'INSIGHTS')}
					maxValue={25}
					barColor='#ffbc89'
					subject={'Insights'}
				/>
				<div className='ta-result-summary_small-header'>
					{renderSummaryScoreTitle(totalScore)}
				</div>
				<div className='ta-result-summary_small-text'>
					{renderSummaryScoreText(totalScore)}
				</div>
				<a href={`https://app.wixanswers.com/mk-signup?em=${encodeText(email)}`}>
					<button className='ta-result-summary_button'>
						Try for free
					</button>
				</a>
				<div className='ta-result-summary_disclaimer'>
					No credit card needed
				</div>
			</div>
		</div>
	);
};
